import { render, staticRenderFns } from "./Sangfor.vue?vue&type=template&id=a66eb7d2"
import script from "./Sangfor.vue?vue&type=script&lang=js"
export * from "./Sangfor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports